import React, { PropsWithChildren, useState } from "react"

import { ModalProvider } from "./ModalProvider"
import { ModalContext } from "./ModalContext"
import { ModalsKeys } from "./Modals/ModalTypes"
import type { ModalContextProps } from "./Modals/ModalTypes"

const contextDefaultValues = {
    modal: ModalsKeys.None,
    setModal: () => {},
    setProps: () => {},
    props: {},
} satisfies {
    modal: ModalsKeys
    setModal: (modal: ModalsKeys) => void
    setProps: (props: ModalContextProps) => void
    props: ModalContextProps
}

export const ModalContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [modal, setModal] = useState<ModalsKeys>(contextDefaultValues.modal)
    const [props, setProps] = useState(contextDefaultValues.props)

    return (
        <ModalContext.Provider
            value={{
                modal,
                setModal,
                props,
                setProps,
            }}>
            <ModalProvider>{children}</ModalProvider>
        </ModalContext.Provider>
    )
}
